/** Keep per-player Ante and big-blind Ante distinct in timer displays. */
export function forcedBets(ante = 0, bba = 0) {
  return [
    { label: 'ANTE', value: ante },
    { label: 'BBA', value: bba },
  ].filter(({ value }) => value > 0);
}

export function formatForcedBets(ante = 0, bba = 0): string {
  const bets = forcedBets(ante, bba).map(
    ({ label, value }) => `${label === 'ANTE' ? 'Ante' : label} ${value.toLocaleString()}`,
  );
  return bets.length ? ` (${bets.join(' / ')})` : '';
}

/** Combine only the current blinds; next-level descriptions keep their labelled format. */
export function currentBlinds(
  smallBlind: number,
  bigBlind: number,
  ante = 0,
  bba = 0,
  isBreak = false,
) {
  const bets = isBreak ? [] : forcedBets(ante, bba);
  return {
    label: bets.length ? 'BLINDS/BBA' : 'BLINDS',
    value: [smallBlind, bigBlind, ...bets.map(({ value }) => value)]
      .map((value) => value.toLocaleString())
      .join(bets.length ? '/' : ' / '),
  };
}
